import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

import {HrCalendarDayCellComponent} from './hr-calendar-day-cell/hr-calendar-day-cell.component';
import {HrCalendarHeaderComponent} from './hr-calendar-header/hr-calendar-header.component';
import {HrCalendarMonthPickerComponent} from './hr-calendar-month-picker/hr-calendar-month-picker.component';
import {HrCalendarComponent} from './hr-calendar.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    PopoverModule,
    TooltipModule
  ],
  declarations: [
    HrCalendarComponent,
    HrCalendarHeaderComponent,
    HrCalendarMonthPickerComponent,
    HrCalendarDayCellComponent
  ],
  exports: [
    HrCalendarComponent
  ]
})
export class HrCalendarModule {
}
